import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import useGeoCountry, { useGeoCountryForm } from '@hooks/useGeoCountry'

import PageContext from '@contexts/pageContext'

import CountryDetails from '../GeoCountryDetails'
import PageLayout from '../../../../components/PageLayout'

const PageContent = (props: {geoCountryId: number}) => {
  const { geoCountryId } = props

  const pageContext = useContext(PageContext)
  const { callbacks: { updateGeoCountry } } = pageContext

  const countryPayload = useGeoCountry({ id: geoCountryId })
  const {
    callbacks: {
      updateGeoCountry: updateFn,
    },
    geoCountry,
    loading,
    updating,
  } = countryPayload

  // @ts-expect-error TS2345
  const geoCountryFormPayload = useGeoCountryForm(geoCountry, { validateOn: 'change' })
  const { entityState, saveEnabled } = geoCountryFormPayload

  const updateGeoCountryPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Country Updated',
  }

  return (
    <PageLayout entityPayload={countryPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            {/*
             // @ts-expect-error TS2322 */}
            <CountryDetails geoCountry={geoCountry} geoCountryFormPayload={geoCountryFormPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                //@ts-expect-error
                marginLeft="auto"
                onClick={() => updateGeoCountry(updateGeoCountryPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

    </PageLayout>
  )
}

export default PageContent
